import App from "./App";
import React from "react";
import { hydrate } from "react-dom";
import { version } from "./utility/version";

hydrate(<App />, document.getElementById("rcBody"));

console.log(`version ${version}`);

if (module.hot) {
  module.hot.accept();
}
